/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as GameRouteImport } from './routes/game'
import { Route as CreatorRouteImport } from './routes/creator'

const GameRoute = GameRouteImport.update({
  id: '/game',
  path: '/game',
  getParentRoute: () => rootRouteImport,
} as any)
const CreatorRoute = CreatorRouteImport.update({
  id: '/creator',
  path: '/creator',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/creator': typeof CreatorRoute
  '/game': typeof GameRoute
}
export interface FileRoutesByTo {
  '/creator': typeof CreatorRoute
  '/game': typeof GameRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/creator': typeof CreatorRoute
  '/game': typeof GameRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/creator' | '/game'
  fileRoutesByTo: FileRoutesByTo
  to: '/creator' | '/game'
  id: '__root__' | '/creator' | '/game'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  CreatorRoute: typeof CreatorRoute
  GameRoute: typeof GameRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/game': {
      id: '/game'
      path: '/game'
      fullPath: '/game'
      preLoaderRoute: typeof GameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/creator': {
      id: '/creator'
      path: '/creator'
      fullPath: '/creator'
      preLoaderRoute: typeof CreatorRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  CreatorRoute: CreatorRoute,
  GameRoute: GameRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
